import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CountUp from 'react-countup';
import './StatsSection.css';

const StatsSection = ({ animatedItems, statsRef }) => {
  return (
    <section className="stats-section" ref={statsRef}>
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="section-title">Our Impact</h2>
            <div className="title-underline mx-auto"></div>
            <p className="section-subtitle">
              Making a difference in agricultural production worldwide
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={3} sm={6} className="text-center mb-4">
            <div className="stat-item">
              <div className="stat-icon">
                <i className="bi bi-people"></i>
              </div>
              <h3 className="stat-number">
                {animatedItems.stats ? (
                  <CountUp end={10000} suffix="+" duration={2.5} />
                ) : (
                  "0+"
                )}
              </h3>
              <p className="stat-text">Farmers Supported</p>
            </div>
          </Col>
          <Col md={3} sm={6} className="text-center mb-4">
            <div className="stat-item">
              <div className="stat-icon">
                <i className="bi bi-award"></i>
              </div>
              <h3 className="stat-number">
                {animatedItems.stats ? (
                  <CountUp end={12} suffix="+" duration={2.5} />
                ) : (
                  "0+"
                )}
              </h3>
              <p className="stat-text">Years of Excellence</p>
            </div>
          </Col>
          <Col md={3} sm={6} className="text-center mb-4">
            <div className="stat-item">
              <div className="stat-icon">
                <i className="bi bi-graph-up"></i>
              </div>
              <h3 className="stat-number">
                {animatedItems.stats ? (
                  <CountUp end={30} suffix="%" duration={2.5} />
                ) : (
                  "0%"
                )}
              </h3>
              <p className="stat-text">Avg. Productivity Increase</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default StatsSection;